import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Container } from '../Container/Container'
import Button from '../Button/Button'
import Logos from '../Logos/Logos'
import PopupNew from '../PopupNew/PopupNew'
import Feedback from '../Feedback/Feedback'
import { Small } from "../../styles/typography/typography"
import { colors as c } from "../../styles/variables"
import {
    FooterSt,
    WrapperSt,
    WrapperLogosSt,
    WrapperBottomSt,
    LinkSt,
    WrapperTextSt,
    BrSt,
} from "./style";

import i18n from "i18next";
import { withTranslation } from "react-i18next";

const Footer = ({ channelContent }) => {
    const [popupIsOpen, setPopupIsOpen] = useState(false);
    const loadButtonText = useSelector((state) => state.channelContent.loadButtonText)

    const handleOpenPopupClick = (e) => {
        e.preventDefault();
        setPopupIsOpen((prev) => !prev);
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    const year = new Date().getFullYear();

    return (
        <>
            <FooterSt>
                <Container padding="true">
                    <WrapperSt>
                        {(i18n.language === 'en') ?
                            <a href="documents/catalogue_eng.pdf" download >
                                <Button as="a" href="/" label={loadButtonText} size="big" primary />
                            </a>
                            :
                            <a href="documents/catalogue_rus.pdf" download >
                                <Button as="a" label={loadButtonText} size="big" primary />
                            </a>
                        }
                        <WrapperLogosSt>
                            <Logos channelContent={channelContent} container="footer" size="medium" color={c.white} />
                        </WrapperLogosSt>
                    </WrapperSt>
                    <WrapperBottomSt>
                        <WrapperTextSt>
                            {(((window.innerHeight <= 800) && (window.innerWidth > 768)) ||
                                ((window.innerHeight === 1024) && (window.innerWidth === 768)) ||
                                window.innerWidth < 768)
                                ?
                                <p onClick={() => scrollToTop()}>
                                    <LinkSt to="/feedback">{i18n.t(`footer.feedback`)}</LinkSt>
                                </p>
                                :
                                <p onClick={(e) => handleOpenPopupClick(e)}><Small> {i18n.t(`footer.feedback`)}</Small></p>
                            }
                            <Small>Copyright {i18n.t(`footer.gpm`)} {year} <BrSt />©&nbsp;All Rights Reserved</Small>
                        </WrapperTextSt>
                    </WrapperBottomSt>
                </Container>
            </FooterSt>
            {
                (popupIsOpen && window.innerWidth > 768)
                &&
                <PopupNew handleOpenPopupClick={handleOpenPopupClick}>
                    <Feedback handleOpenPopupClick={handleOpenPopupClick} />
                </PopupNew>
            }
        </>
    );
};

export default withTranslation()(Footer);
